/* TotalPantofi - cautare brand -> pagina brandului (04.11.2026).
   Cand textul cautat (bara de sus, cautarea din pagina, Enter in sugestii sau un link /search?q=...) este EXACT un brand
   pe care il avem in stoc, clientul ajunge direct pe pagina brandului, nu pe lista de rezultate.
   Fisierul se incarca in <head> (sincron, mic) ca redirectul sa porneasca inainte de randarea paginii /search.
   Interogari cu mai multe cuvinte ("pantofi skechers dama") raman cautari normale. ?tpb=0 dezactiveaza redirectul.
   Lista e generata din catalog (brandurile cu stoc; nume generice gen "Pro"/"Relax"/"Silver" sunt excluse deliberat):
   un brand nou se adauga in B (cheie = litere+cifre minuscule, fara diacritice/spatii). */
(function () {
  'use strict';
  var B = {
    "aga": ["Aga","/collections/vendors?q=Aga"],
    "anekke": ["Anekke","/collections/anekke"],
    "annaviotti": ["Anna Viotti","/collections/anna-viotti"],
    "antonio": ["Antonio","/collections/antonio"],
    "bioflex": ["Bio Flex","/collections/bio-flex"],
    "bratex": ["Bratex","/collections/bratex"],
    "caprice": ["Caprice","/collections/caprice"],
    "caspian": ["Caspian","/collections/vendors?q=Caspian"],
    "cobra": ["Cobra","/collections/cobra"],
    "conhpol": ["Conhpol","/collections/conhpol"],
    "decar": ["Decar","/collections/vendors?q=Decar"],
    "dogati": ["Dogati","/collections/dogati"],
    "dyany": ["Dyany","/collections/vendors?q=Dyany"],
    "ecobio": ["Eco Bio","/collections/vendors?q=Eco%20Bio"],
    "eldemas": ["Eldemas","/collections/eldemas"],
    "epica": ["Epica","/collections/epica"],
    "formazione": ["Formazione","/collections/formazione"],
    "francogerardo": ["Franco Gerardo","/collections/franco-gerardo"],
    "fratelli": ["Fratelli","/collections/vendors?q=Fratelli"],
    "goretti": ["Goretti","/collections/goretti"],
    "jana": ["Jana","/collections/vendors?q=Jana"],
    "jomix": ["Jomix","/collections/jomix"],
    "josesimon": ["Jose Simon","/collections/jose-simon"],
    "karisma": ["Karisma","/collections/karisma"],
    "marcotozzi": ["Marco Tozzi","/collections/marco-tozzi"],
    "mels": ["Mels","/collections/mels"],
    "mondex": ["Mondex","/collections/vendors?q=Mondex"],
    "nicolis": ["Nicolis","/collections/nicolis"],
    "otter": ["Otter","/collections/otter"],
    "pass": ["Pass","/collections/pass"],
    "perlla": ["Perlla","/collections/perlla"],
    "pikolinos": ["Pikolinos","/collections/pikolinos"],
    "proartimar": ["Proartimar","/collections/vendors?q=Proartimar"],
    "remonte": ["REMONTE","/collections/remonte"],
    "rieker": ["Rieker","/collections/rieker"],
    "skechers": ["Skechers","/collections/skechers"],
    "soliver": ["S.OLIVER","/collections/vendors?q=S.OLIVER"],
    "suave": ["Suave","/collections/suave"],
    "tamaris": ["Tamaris","/collections/tamaris"],
    "waldlaufer": ["Waldlaufer","/collections/vendors?q=Waldlaufer"]
  };
  var A = {
    "sketchers": "skechers",
    "skecher": "skechers",
    "sketcher": "skechers",
    "skechars": "skechers",
    "riker": "rieker",
    "marcotozi": "marcotozzi",
    "francogerrardo": "francogerardo",
    "soliver": "soliver"
  };
  function key(s) {
    s = String(s == null ? '' : s).toLowerCase();
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    return s.replace(/[^a-z0-9]+/g, '');
  }
  function find(q) {
    var k = key(q);
    if (!k) return null;
    k = A[k] || k;
    return Object.prototype.hasOwnProperty.call(B, k) ? B[k] : null;
  }
  window.tpBrandUrl = find;
  if (/[?&]tpb=0(&|$)/.test(location.search)) return;
  try {
    if (location.pathname === '/search' || location.pathname === '/search/') {
      var hit = find(new URLSearchParams(location.search).get('q'));
      if (hit) { location.replace(hit[1]); return; }
    }
  } catch (e) {}
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    var act = f.getAttribute('action') || '';
    if (!/^(https?:\/\/[^/]+)?\/search\/?(\?|$)/.test(act)) return;
    var inp = f.querySelector('input[name="q"]');
    if (!inp) return;
    var hit = find(inp.value);
    if (!hit) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    try { if (window.tpRecentSave) window.tpRecentSave(inp.value); } catch (err) {}
    location.href = hit[1];
  }, true);
})();
